// extracted by mini-css-extract-plugin
module.exports = {"BoxProps":"BoxProps_BoxProps__2RXPQ"};